export const CONTACT = {
    phoneDisplay: "+91 79804 26915",
    phoneHref: "tel:+917980426915",
    whatsappHref:
        "https://wa.me/917980426915?text=Hello%20NoirNest%2C%20I%27d%20like%20to%20begin%20my%20design%20journey.",
    email: "support.noirnest@gmail.com",
    emailHref: "mailto:support.noirnest@gmail.com",
    instagram: "@Noirnest_Interior",
    instagramHref: "https://instagram.com/Noirnest_Interior",
};

export const NAV_LINKS = [
    { label: "Home", to: "/", testid: "nav-link-home" },
    { label: "Studio", to: "/studio", testid: "nav-link-studio" },
    { label: "Works", to: "/works", testid: "nav-link-works" },
    { label: "Services", to: "/services", testid: "nav-link-services" },
    { label: "Contact", to: "/contact", testid: "nav-link-contact" },
];

export const MARQUEE_ITEMS = [
    "Japandi",
    "Minimalist Contemporary",
    "Art Deco",
    "Custom Narratives",
    "Handcrafted in Kolkata",
    "Conceived Together",
    "Engineered Forever",
];

export const STYLES = [
    { number: "01", title: "Japandi", text: "A quiet balance of warmth and minimalism." },
    { number: "02", title: "Minimalist Contemporary", text: "Clarity, openness, and restraint." },
    { number: "03", title: "Art Deco", text: "Bold geometry and expressive elegance." },
    { number: "04", title: "Custom Narratives", text: "Designs shaped entirely around you." },
];

export const PILLARS = [
    {
        number: "01",
        title: "Client-Led Vision, Expertly Guided",
        text: "You create your space—we help you shape it. Through insight and experience, we guide your decisions, ensuring your vision becomes both expressive and practical.",
        points: [],
    },
    {
        number: "02",
        title: "Creative Freedom Within Intelligent Boundaries",
        text: "We define thoughtful frameworks—space, materials, and budget—so you can explore freely while maintaining clarity and control.",
        points: [],
    },
    {
        number: "03",
        title: "Agile Execution & Financial Alignment",
        text: "Our process is designed to give you confidence. No rigid commitments. No unnecessary risk. Only a system built on transparency and trust.",
        points: ["Phase-wise execution", "Milestone-based payments", "Flexibility to pause, adapt, or refine"],
    },
    {
        number: "04",
        title: "Element-Based Costing",
        text: "We move beyond per square-foot pricing. Your project is broken into individual elements—your budget follows your priorities, not the other way around.",
        points: ["Full visibility", "Flexible allocation", "Priority-based decisions"],
    },
];

export const SERVICES = [
    {
        id: "interior-design",
        number: "01",
        title: "Interior Design & Space Planning",
        text: "Bespoke spatial layouts, tailored furniture curation, acoustic balance, and custom lighting schemes crafted for living harmony.",
    },
    {
        id: "exterior-facade",
        number: "02",
        title: "Exterior & Facade Design",
        text: "Architectural envelope elevation, climate-responsive materials, dynamic louvers, and lasting curb appeal.",
    },
    {
        id: "solar-energy",
        number: "03",
        title: "Solar Energy Integration",
        text: "Seamless rooftop solar architectural integration, energy storage systems, and a sustainable green footprint.",
    },
    {
        id: "home-automation",
        number: "04",
        title: "Home Automation Systems",
        text: "Intelligent climate control, automated mood lighting, smart security access, and voice-integrated living.",
    },
    {
        id: "civil-construction",
        number: "05",
        title: "Civil Construction & Structural Works",
        text: "Full structural execution, foundation strength, and reinforcement—precision overseen by certified engineers.",
    },
    {
        id: "temporary-structures",
        number: "06",
        title: "Temporary Structures",
        text: "Architectural pavilions, exhibit installations, and modular pop-up spaces engineered for rapid deployment.",
    },
    {
        id: "water-leakage-solutions",
        number: "07",
        title: "Water Leakage & Structural Solutions",
        text: "Advanced damp-proofing, terrace waterproofing, and structural restoration designed for tropical longevity.",
    },
];

const U = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1400&q=80`;

export const HERO_IMAGE = {
    src: "https://images.unsplash.com/photo-1772797583328-f83bc3f94f80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxqYXBhbmRpJTIwaW50ZXJpb3IlMjBsaXZpbmclMjByb29tJTIwbWluaW1hbCUyMHdhcm0lMjB3b29kJTIwZGVzaWdufGVufDB8fHx8MTc4ODE4MDMwMHww&ixlib=rb-4.1.0&q=85&w=1200",
    alt: "Japandi living room in warm wood tones designed by Noir Nest",
    caption: "The Wabi-Sabi Sanctuary — Alipore, Kolkata",
};

export const STUDIO_IMAGE = {
    src: "https://images.pexels.com/photos/8251251/pexels-photo-8251251.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    alt: "Handcrafted rattan and wood interior detail",
    caption: "Natural rattan, limewash plaster, hand-bent wood",
};

export const CRAFT_IMAGE = {
    src: "https://images.pexels.com/photos/8251242/pexels-photo-8251242.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    alt: "Crafted interior material detail in warm tones",
    caption: "Materials chosen to age gracefully",
};

export const PROJECTS = [
    {
        id: "proj-1",
        title: "The Wabi-Sabi Sanctuary",
        category: "Japandi Living",
        filter: "japandi",
        location: "Alipore, Kolkata",
        src: "https://images.unsplash.com/photo-1772797583328-f83bc3f94f80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxqYXBhbmRpJTIwaW50ZXJpb3IlMjBsaXZpbmclMjByb29tJTIwbWluaW1hbCUyMHdhcm0lMjB3b29kJTIwZGVzaWdufGVufDB8fHx8MTc4ODE4MDMwMHww&ixlib=rb-4.1.0&q=85&w=1400",
        text: "Minimalist organic textures paired with warm white-oak panelling and soft ambient cove lighting.",
        aspect: "aspect-[4/5]",
    },
    {
        id: "proj-2",
        title: "Earthy Minimalist Penthouse",
        category: "Minimalist Contemporary",
        filter: "minimalist",
        location: "Ballygunge, Kolkata",
        src: "https://images.unsplash.com/photo-1693578616322-c8abe6c7393d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHozfHxqYXBhbmRpJTIwaW50ZXJpb3IlMjBsaXZpbmclMjByb29tJTIwbWluaW1hbCUyMHdhcm0lMjB3b29kJTIwZGVzaWdufGVufDB8fHx8MTc4ODE4MDMwMHww&ixlib=rb-4.1.0&q=85&w=1400",
        text: "Custom low-profile lounge seating with travertine stone surfaces and floor-to-ceiling glass.",
        aspect: "aspect-[4/5]",
    },
    {
        id: "proj-3",
        title: "Art Deco Residence",
        category: "Art Deco",
        filter: "artdeco",
        location: "New Town, Kolkata",
        src: U("photo-1701789668339-140f67db12df"),
        text: "Fluted limestone walls, brass inlay details, and custom architectural sconces.",
        aspect: "aspect-[4/5]",
    },
    {
        id: "proj-4",
        title: "Bespoke Dining Pavilion",
        category: "Custom Narratives",
        filter: "custom",
        location: "Salt Lake, Kolkata",
        src: U("photo-1680773525468-eda783c5bfe7"),
        text: "Warm teak herringbone flooring with a custom floating credenza and sculpted seating.",
        aspect: "aspect-[4/5]",
    },
    {
        id: "proj-5",
        title: "Zen Lounge & Tea Corner",
        category: "Japandi Living",
        filter: "japandi",
        location: "Southern Avenue, Kolkata",
        src: "https://images.pexels.com/photos/8251251/pexels-photo-8251251.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
        text: "Natural rattan weave, limewash plaster walls, and hand-bent wooden furniture.",
        aspect: "aspect-[4/5]",
    },
    {
        id: "proj-6",
        title: "Architectural Facade Villa",
        category: "Exterior & Facade",
        filter: "custom",
        location: "Rajarhat, Kolkata",
        src: U("photo-1680770638423-6d4c1089bd7a"),
        text: "Geometric facade louvers with integrated warm LED cove channels and courtyard views.",
        aspect: "aspect-[4/5]",
    },
];

export const FILTERS = [
    { id: "all", label: "All Works", testid: "projects-filter-tab-all" },
    { id: "japandi", label: "Japandi", testid: "projects-filter-tab-japandi" },
    { id: "minimalist", label: "Minimalist", testid: "projects-filter-tab-minimalist" },
    { id: "artdeco", label: "Art Deco", testid: "projects-filter-tab-artdeco" },
];

const IG = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=800&q=80`;

export const TESTIMONIALS = [
    {
        id: "t-1",
        quote: "They never once showed us a catalogue. Every conversation started with how we actually live—and the home we got back feels like it was always ours.",
        name: "Ritika & Arnab Sen",
        project: "Wabi-Sabi Sanctuary · Alipore",
    },
    {
        id: "t-2",
        quote: "Element-based costing changed everything. We knew exactly where every rupee went and could shift budget to the things that mattered to us.",
        name: "Debashish Mukherjee",
        project: "Penthouse Interiors · Ballygunge",
    },
    {
        id: "t-3",
        quote: "Having architects and engineers on the same team meant no surprises on site. The finish is beautiful, but it's the details you can't see that we trust most.",
        name: "Priya Agarwal",
        project: "Art Deco Residence · New Town",
    },
    {
        id: "t-4",
        quote: "Three years on, nothing has warped, chipped or dated. That is what 'engineered forever' turned out to mean in practice.",
        name: "Sourav Chatterjee",
        project: "Dining Pavilion · Salt Lake",
    },
];

export const INSTAGRAM_POSTS = [
    { id: "ig-1", src: IG("photo-1616486338812-3dadae4b4ace"), alt: "Warm minimal living room", caption: "Site diaries — warm minimal living, Alipore" },
    { id: "ig-2", src: IG("photo-1618221195710-dd6b41faaea6"), alt: "Dramatic luxury interior detail", caption: "Evening tones, Ballygunge penthouse" },
    { id: "ig-3", src: IG("photo-1600210492486-724fe5c67fb0"), alt: "Neutral living room with soft arches", caption: "Soft arches, quiet mornings" },
    { id: "ig-4", src: IG("photo-1586023492125-27b2c045efd7"), alt: "Cream armchair with wooden side table", caption: "Quiet corners, considered" },
    { id: "ig-5", src: IG("photo-1600607687920-4e2a09cf159d"), alt: "Dining space with natural textures", caption: "Gathering spaces that feel natural" },
    { id: "ig-6", src: IG("photo-1616594039964-ae9021a400a0"), alt: "Contemporary interior vignette", caption: "Details, conceived together" },
];
